import http from './HttpService';

export type IRegisterInput = {
  email: string;
  password: string;
  cpassword: string;
  firstName: string;
  lastName: string;
};

export type SsoProvider = 'google' | 'facebook' | 'line';

const apiBase = `${process.env.REACT_APP_API_URL}/api/${process.env.REACT_APP_API_VERSION}`;

export function login(email: string, password: string) {
  return http.post('/users/signin/prl?isWeb=true', { email: email, password: password });
}

export function logout() {
  return http.delete('/users/signout');
}

export function signup(data: IRegisterInput) {
  const body = {
    email: data.email,
    password: data.password,
    name: {first: data.firstName, last: data.lastName},
    role: 'admin',
  };
  return http.post('/users/signup/prl',{user: body});
}

export function forgotPassword(email: string) {
  return http.get(`/users/resetpassword?email=${email}`);
}

export function resetPassword(password: string, authKey: string) {
  return http.put(`/users/resetpassword`, {authKey: authKey, password: password});
}

export function initiateSSO(provider: SsoProvider) {
  // Use window.location.origin as fallback so the SSO redirect always inherits
  // the current page protocol (http vs https), preventing mixed-content errors.
  const ssoApiBase = process.env.REACT_APP_API_URL
    ? `${process.env.REACT_APP_API_URL}/api/${process.env.REACT_APP_API_VERSION}`
    : `${window.location.origin}/api/${process.env.REACT_APP_API_VERSION}`;
  const redirectUrl = encodeURIComponent(window.location.origin);
  window.location.href = `${ssoApiBase}/users/auth/${provider}?isWeb=true&redirectUrl=${redirectUrl}`;
}

const auth = {
  login,
  logout,
  signup,
  forgotPassword,
  resetPassword,
  initiateSSO,
};

export default auth;
